import { type VisualizationData } from '~components/business-owner/barry/chart/BarryChart';

import { type BarryMessagesList } from '~api/common/barry/barry';

import { type ChatItem, type ChatItemKind } from './types/chatItem';

export const isTemporaryMessageId = (id: string): boolean => id.startsWith('temp-');

const formatMessageToChat = (message: BarryMessagesList): ChatItem => ({
	id: message.id,
	kind: message.role === 'assistant' ? 'assistant' : 'user',
	content: message.content,
	visualization: message.metadata?.visualization as VisualizationData | undefined,
});

export const processBarryMessages = (
	messages: BarryMessagesList[] | undefined,
): ChatItem[] =>
	(messages ?? []).filter((m) => m.role !== 'system').map(formatMessageToChat);

export const buildTempItem = (
	kind: ChatItemKind,
	content: string,
	visualization?: VisualizationData,
): ChatItem => ({
	id: `temp-${crypto.randomUUID()}`,
	kind,
	content,
	...(visualization && { visualization }),
});

export const updateOrAppendAssistantStream = (
	prev: ChatItem[],
	content: string,
	visualization?: VisualizationData,
): ChatItem[] => {
	const withoutStatus = prev.filter((item) => item.kind !== 'status');
	const last = withoutStatus[withoutStatus.length - 1];
	if (last?.kind === 'assistant' && isTemporaryMessageId(last.id)) {
		return [
			...withoutStatus.slice(0, -1),
			{ ...last, content, ...(visualization && { visualization }) },
		];
	}
	return [...withoutStatus, buildTempItem('assistant', content, visualization)];
};
